module.exports = __webpack_public_path__ + "static/media/practice-selected.918979bb.svg";